var _FooterMap$APP_CONFIG;
import { DEFAULT_FOOTER } from "@lib/constants";
import APP_CONFIGURATION from "@lib/app.config";
import FooterBancogral from "./templates/footer-bancogral";
import FooterInterbank from "./templates/footer-interbank";
import FooterDefault from "./templates/footer-default";
const FooterMap = {
  'footer-default': FooterDefault,
  'bancogral': FooterBancogral,
  'interbank': FooterInterbank
};
const Footer = (_FooterMap$APP_CONFIG = FooterMap[APP_CONFIGURATION.config.appFooter]) !== null && _FooterMap$APP_CONFIG !== void 0 ? _FooterMap$APP_CONFIG : FooterMap[DEFAULT_FOOTER];
export default Footer;